import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=f7242d12&scoped=true"
var script = {}
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=f7242d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7242d12",
  null
  
)

export default component.exports